var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import * as Styled from "./HeadingStyles";
var Heading = function (_a) {
    var className = _a.className, children = _a.children, size = _a.size, withoutMargins = _a.withoutMargins, textAlign = _a.textAlign, props = __rest(_a, ["className", "children", "size", "withoutMargins", "textAlign"]);
    return (React.createElement(Styled.Heading, __assign({ textAlign: textAlign, size: size, withoutMargins: withoutMargins }, props), children));
};
export default Heading;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGluZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkhlYWRpbmcudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMvQixPQUFPLEtBQUssTUFBTSxNQUFNLGlCQUFpQixDQUFDO0FBVTFDLElBQU0sT0FBTyxHQUFHLFVBQUMsRUFPTjtJQU5ULElBQUEsU0FBUyxlQUFBLEVBQ1QsUUFBUSxjQUFBLEVBQ1IsSUFBSSxVQUFBLEVBQ0osY0FBYyxvQkFBQSxFQUNkLFNBQVMsZUFBQSxFQUNOLEtBQUssY0FOTyxnRUFPaEIsQ0FEUztJQUVSLE9BQU8sQ0FDTCxvQkFBQyxNQUFNLENBQUMsT0FBTyxhQUFDLFNBQVMsRUFBRSxTQUFTLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxjQUFjLEVBQUUsY0FBYyxJQUFNLEtBQUssR0FDeEYsUUFBUSxDQUNNLENBQ2xCLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLE9BQU8sQ0FBQyJ9